"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModuleBase = _interopRequireDefault(require("./ModuleBase"));

var _ModuleLink = _interopRequireDefault(require("./ModuleLink"));

var _ModuleActionPrimary = _interopRequireDefault(require("./ModuleActionPrimary"));

var _ModuleActionbar = _interopRequireDefault(require("./ModuleActionbar"));

var _ModuleMedia = _interopRequireDefault(require("./ModuleMedia"));

var _ModuleTitle = _interopRequireDefault(require("./ModuleTitle"));

var _ModuleLabel = _interopRequireDefault(require("./ModuleLabel"));

var _ModuleDescription = _interopRequireDefault(require("./ModuleDescription"));

var _ModuleStatus = _interopRequireDefault(require("./ModuleStatus"));

var _ModuleByline = _interopRequireDefault(require("./ModuleByline"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: props => {
      return props.width;
    },
    userSelect: "none",
    "&[data-status=erased]": {
      "& figure": {
        opacity: "0.5"
      },
      "& $content": {
        opacity: "0.5"
      }
    },
    "&[data-status=trash]": {
      "& figure": {
        opacity: "0.5"
      },
      "& $content": {
        opacity: "0.5"
      }
    }
  },
  leadingIcon: {
    position: "absolute",
    zIndex: 3,
    top: 0,
    right: 'auto',
    bottom: "auto",
    left: 0
  },
  actionbar: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    width: props => {
      return props.width;
    },
    height: props => {
      return props.height;
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: "0",
    "& button[name=select]": {
      position: "absolute",
      top: 0,
      right: 0
    },
    "& button[name=toggle]": {
      position: "absolute",
      top: 0,
      right: 0
    }
  },
  content: {
    flexDirection: "column",
    display: "flex",
    alignItems: "left",
    justifyContent: "flex-start"
  },
  header: {
    width: "100%",
    flexBasis: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: theme.spacing(.5)
  },
  body: {
    width: "100%",
    flexBasis: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  footer: {
    display: "flex",
    alignItems: "baseline",
    width: "100%",
    flexBasis: "100%",
    justifyContent: "flex-start",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  }
}));

const CardModule = (_ref) => {
  let _ref$width = _ref.width,
      width = _ref$width === void 0 ? 180 : _ref$width,
      maxWidth = _ref.maxWidth,
      mediaStyle = _ref.mediaStyle,
      _ref$mediaHeight = _ref.mediaHeight,
      mediaHeight = _ref$mediaHeight === void 0 ? 180 : _ref$mediaHeight,
      _ref$mediaLayout = _ref.mediaLayout,
      mediaLayout = _ref$mediaLayout === void 0 ? "contain" : _ref$mediaLayout,
      selected = _ref.selected,
      imageUrl = _ref.imageUrl,
      title = _ref.title,
      description = _ref.description,
      type = _ref.type,
      typeLabel = _ref.typeLabel,
      status = _ref.status,
      statusLabel = _ref.statusLabel,
      author = _ref.author,
      datetime = _ref.datetime,
      onClick = _ref.onClick,
      onEdit = _ref.onEdit,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "maxWidth", "mediaStyle", "mediaHeight", "mediaLayout", "selected", "imageUrl", "title", "description", "type", "typeLabel", "status", "statusLabel", "author", "datetime", "onClick", "onEdit"]);

  if (maxWidth) {
    width = maxWidth;
  }

  const classes = useStyles({
    width: width,
    height: mediaHeight
  });
  const media = {
    selected: selected,
    layout: mediaLayout,
    imageUrl: imageUrl || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==",
    width: width,
    height: mediaHeight
  };
  return _react.default.createElement(_ModuleBase.default, _extends({}, props, {
    elevation: 1,
    className: classes.root,
    selected: selected,
    status: status,
    onClick: onClick
  }), _react.default.createElement(_ModuleMedia.default, media), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_ModuleTitle.default, {
    title: title,
    status: status,
    onClick: onClick && undefined || onEdit
  })), _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement(_ModuleLabel.default, {
    label: typeLabel || type
  }), _react.default.createElement(_ModuleStatus.default, {
    status: statusLabel || status
  })), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_ModuleByline.default, {
    author: author,
    datetime: datetime
  }))));
};

CardModule.propTypes = process.env.NODE_ENV !== "production" ? {
  imageUrl: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  type: _propTypes.default.string,
  typeLabel: _propTypes.default.string,
  status: _propTypes.default.string,
  statusLabel: _propTypes.default.string,
  author: _propTypes.default.string,
  datetime: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onEdit: _propTypes.default.func
} : {};
var _default = CardModule;
exports.default = _default;
module.exports = exports.default;